import { render, staticRenderFns } from "./IdBadge.vue?vue&type=template&id=31233108&lang=pug&"
import script from "./IdBadge.vue?vue&type=script&lang=ts&"
export * from "./IdBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports